import Amount from "@/models/Shared/Amount";
import ScheduleInstallment from "@/models/Accounts/LendingAccounts/Schedules/ScheduleInstallment";

export default class Schedule {
    totalAmount: Amount;
    totalPrincipal: Amount;
    totalInterest: Amount;
    schedule: ScheduleInstallment[];
}